import D28dTrainersAdmin from '../d28d/D28dTrainersAdmin';

/** Entrenadores operativos del gimnasio virtual (rol entrenador_gym, scope por sede). */
export default function GymMastersTrainers({ onBack, scopeGymId = null, scopeGymName = '' }) {
  return (
    <D28dTrainersAdmin
      gymScoped
      scopeGymId={scopeGymId}
      scopeGymName={scopeGymName}
      onBack={onBack}
      hasAnyRole={() => true}
    />
  );
}
